import { usePageVisibility } from './usePageVisibility'

/**
 * Returns the given polling interval when the tab is visible, or 0 (disabled) when hidden.
 * Falls back to the original interval if anything goes wrong.
 */
export function usePollingInterval(interval: number): number {
  try {
    const isVisible = usePageVisibility()
    return isVisible ? interval : 0
  } catch {
    return interval
  }
}
